export interface UserSession {
	isLoggedIn: boolean;

	/** '1' for admin users, '0' for customer accounts. */
	tm_admin: "1" | "0";

	displayName: string;
}

export interface CustomerSession extends UserSession, CustomerProductPrivileges {
	tm_admin: "0";

	isActive: boolean;
	isBlocked: boolean;

	wmsId: string;
	country: string;

	/** Only (optionally) present on Partner-API customer sessions of CA Office */
	caoffice_supportuntil?: string; // "2025-01-01 00:00:00" (CA Office reads only the first 10 date chars)
	caoffice_distributor?: string; // "CA DIGITAL"
	caoffice_version?: string; // "1.0"

	/** Only present on Partner-API customer sessions of OrthoAssistant */
	ortho_assistant_licenseuntil?: string; // "2025-01-01"

	/** @deprecated field name and type until v2.4.0. Removed in 2.5.0 */
	ca_certified_professional?: string;
	/** @deprecated field name and type until v2.4.0. Removed in 2.5.0 */
	functionalsplint_certified?: string;
	/** @deprecated field name and type until v2.4.0. Removed in 2.5.0 */
	orcadent_certified?: string;
	/**@deprecated */
	entity_id?: string;
}

export interface AdminSession extends UserSession {
	tm_admin: "1";

	roles: InternalUserRole[];

	adminData: {
		username: string;
		user_id: string;
	};
}

/**
 * @deprecated
 */
export interface LegacyUserMagento {
	/** @deprecated */ is_active?: string;
	/** @deprecated */ am_is_activated: string;
	/** @deprecated */ attribute_set_id: string;
	/** @deprecated */ bulkOrdersOnly: boolean;
	/** @deprecated */ ca_customs_tariff: string;
	/** @deprecated */ ca_delivery_term: string;
	/** @deprecated */ caCertification?: string;
	/** @deprecated */ caCustomerType?: string;
	/** @deprecated */ casmart3d_customer: string;
	/** @deprecated */ casmart3d_version: string;
	/** @deprecated */ country_area: string;
	/** @deprecated */ country: string;
	/** @deprecated */ created_at: Date;
	/** @deprecated */ created_in: string;
	/** @deprecated */ customer_type: string;
	/** @deprecated */ customer_zahlungsziel: string;
	/** @deprecated */ default_billing: string;
	/** @deprecated */ default_shipping: string;
	/** @deprecated */ disable_auto_group_change: string;
	/** @deprecated */ email: string;
	/** @deprecated */ firstname: string;
	/** @deprecated */ lastname: string;
	/** @deprecated */ notes: string;
	/** @deprecated */ entity_id: string;
	/** @deprecated */ entity_type_id: string;
	/** @deprecated */ group_id: string;
	/** @deprecated */ group_name: string;
	/** @deprecated */ increment_id?: any;
	/** @deprecated */ lang: string;
	/** @deprecated */ oldwms_id?: string;
	/** @deprecated */ password_created_at: string;
	/** @deprecated */ prefix: string;
	/** @deprecated */ rp_token: string;
	/** @deprecated */ rp_token_created_at: string;
	/** @deprecated */ store_id: string;
	/** @deprecated */ uid: string;
	/** @deprecated */ updated_at: string;
	/** @deprecated */ website_id: string;

	/** @deprecated */
	flag_zielmodell_desired?: string;

	/** @deprecated */
	flag_neukunde_in?: string;
	/** @deprecated */
	flag_neukunde_mt?: string;

	/** @deprecated */
	ca_vertriebsstatus?: string;

	/** @deprecated Use `tm_admin` field instead. */
	isLoggedInAsAdmin?: boolean;
}


export interface User extends LegacyUserMagento {
	displayName: string;

	ca_certified_professional?: string;
	functionalsplint_certified?: string;
	orcadent_certified?: string;

	isLoggedIn: boolean;
	tm_admin?: "1" | "0"; // '1' for admin users, '0' for customer accounts.

	/** Only present on customer users */
	wmsId?: string;

	/** Only present on admin users */
	adminRole?: { role_id: string };
	/** Only present on admin users */
	adminData?: {
		username: string;
		/** @deprecated */
		firstname?: string;
		/** @deprecated */
		lastname?: string;
		user_id: string;
	};

	/** Only present on Partner-API customer sessions of CA Office */
	caoffice_supportuntil?: string;
	caoffice_distributor?: string;
	caoffice_version?: string;

	/** Only present on Partner-API customer sessions of OrthoAssistant */
	ortho_assistant_licenseuntil?: string;
}

/** All that we may want to display about a customer. */
export type CustomerBaseInfo = {
	wmsId: string;
	displayName: string;
	email: string;
	country: string;
	sfDirectLink?: string;
};

/** All the product privileges of a customer. */
export type CustomerProductPrivileges = {
	isFunctionALCertified: boolean;
	isPeekRetainerVisible: boolean;
};


export enum InternalUserRole {
	ADMIN = "admin",
	SALES_MANAGER = "sales_manager",
	TEAM_LEADER = "team_leader",
	CASEWORKER = "caseworker",
	EMPLOYEE = "employee"
}


/**
 * @deprecated Do not use
 *
 * Certifications
 *
 * CA Customer Certification Types
 *
 * @origin:  magento customer attribute: 'ca_certified'
 *           delivered via ioApi customerDataHelper as caCertification
 *
 * @store: auth.user.caCertification
 *
 */
export enum Certification {
	Bestandskunde = 'CA-D Bestandskunde',
	Partner = 'CA Partner',
	Systempartner = 'CA-D Systempartner',
	None = 'Nicht zertifiziert'
}

/**
 * @deprecated Do not use
 *
 * CA Customer Type
 *
 * @origin:  magento customer attribute: 'customer_type'
 *           delivered via ioApi customerDataHelper as caCustomerType
 *
 * @store:  auth.user.caCustomerType
 *
 */
export enum CustomerTypes {
	KFO = 'KFO',
	ZA = 'ZA',
	DISTRIBUTOR = 'Distributor',
	LAB_GEWERBLICH = 'Labor gewerblich',
	LAB_KFO = 'Labor KFO',
	UNIVERSITY = 'Universität',
	SONSTIGE = 'Sonstige',
}

//XXX see Magento -> Berechtigungen -> Gruppenberechtigungen
/** @deprecated do not use */
export enum MagentoUserRole
{
	UNDEFINED = "0",
	ADMIN = "1",
    CA_DIGITAL_ADMIN = "3",
    TECHNIKER = "73",
	GUEST = "302",
	//... to be continued ...
	// there are many more, but we honestly don't need any more currently
}

